import { InfoCircledIcon } from "@radix-ui/react-icons";
import clsx from "clsx";

interface FieldsErrorProps {
  id: string;
  className?: string;
  children: string[];
}

export function FieldsError({ id, className, children }: FieldsErrorProps) {
  return (
    <div className="space-y-1">
      {children.map((child, index) => (
        <div
          id={id}
          key={index}
          className={clsx(
            "flex",
            "items-center",
            "font-sans",
            "font-normal",
            "text-sm",
            "leading-normal",
            "text-red-600",
            className
          )}
        >
          <InfoCircledIcon className="mr-1" />
          {child}
        </div>
      ))}
    </div>
  );
}
